import React, {Fragment, ReactNode} from 'react';

export function joinArrayOfReactNodes(nodes: ReactNode[], separator: ReactNode = ''): ReactNode {
    return <>{nodes.map((item, i) => {
        const isLastOne = (i + 1) === nodes.length;

        return <Fragment key={`${separator}-${i}-${nodes.length}`}>{item}{isLastOne ? null : separator}</Fragment>;
    })}</>;
}
